import { useMemo } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import api, { serializeSearchParams } from "../../utils/api";
import { apiUrls } from "../../utils/urls";
import CompletedToDoItemRow from "./CompletedToDoItemRow";

export default function CompletedToDoItemsDialog({
  open,
  onClose,
  impersonatedProfileUuid,
  isMobile,
  folders,
}) {
  const endpoint = apiUrls.scheduling.completedToDoItems(
    impersonatedProfileUuid,
  );

  const dataSource = useMemo(
    () => ({
      getRows: async (params) => {
        const { start, end } = params;
        const size = Math.max(end - start + 1, 1);
        const page = Math.floor(start / size);

        const resp = await api.get(endpoint, {
          params: serializeSearchParams({
            page,
            size,
            keep_related: true,
            order_by: ["-completed_dt"],
            select_related: ['template', 'event_trigger', 'template__event'],
            exclude: ["coverage__coverer", "coverage__coveree__user_profile"],
          }),
        });

        const items = resp.data?.data || [];
        const totalCount = resp.data?.total_count ?? items.length;

        return {
          rows: items.map((item) => ({ id: item.uuid, item })),
          rowCount: totalCount,
        };
      },
    }),
    [endpoint],
  );

  const column = useMemo(
    () => ({
      field: "list",
      headerName: "Completed Items",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ width: "100%" }}>
          <CompletedToDoItemRow item={params.row.item} folders={folders} />
        </Box>
      ),
    }),
    [folders],
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Completed To-do Items</DialogTitle>
      <DialogContent sx={{ p: 0, height: isMobile ? "100%" : 600 }}>
        <DataGridPro
          disableColumnMenu
          disableRowSelectionOnClick
          rowSelection={false}
          hideFooterSelectedRowCount
          hideFooter
          listView
          columns={[column]}
          listViewColumn={column}
          dataSource={dataSource}
          lazyLoading
          paginationModel={{ page: 0, pageSize: 10 }}
          onDataSourceError={(error) => console.log(error)}
          rowHeight={100}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
